
import React, { useState, useContext } from 'react';
import logo from "../img/logo.png";
import "../css/SignUp.css";
import { Link, useNavigate } from 'react-router-dom';
import { GoogleLogin } from '@react-oauth/google';
import { toast } from 'react-toastify';
import { jwtDecode } from 'jwt-decode';
import { LoginContext } from '../context/LoginContext';

export default function SignUp() {
    const { setUserLogin } = useContext(LoginContext);
    const navigate = useNavigate();
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [userName, setUserName] = useState("");
    const [password, setPassword] = useState("");
    const [phone, setPhone] = useState("");
    const [interests, setInterests] = useState("");
    // const [state, setState] = useState("");
    // const [country, setCountry] = useState("");
    const [bio, setBio] = useState("");  // New state for bio
    const [about, setAbout] = useState("");  // New state for About
    const [aboutCount, setAboutCount] = useState(0);
    const [bioCount, setBioCount] = useState(0);
    const [hideSignUp, setHideSignUp] = useState(false);
    

    // Emoji filtering helpers: prefer Unicode property escape; fallback to surrogate-pair check
    const containsEmoji = (s) => {
        if (!s) return false;
        try {
            return /\p{Emoji}/u.test(s);
        } catch (e) {
            return /[\uD800-\uDBFF][\uDC00-\uDFFF]/.test(s);
        }
    };

    const sanitizeInput = (s) => {
        if (!s) return '';
        try {
            // remove all Emoji codepoints
            return s.replace(/\p{Emoji}/gu, '');
        } catch (e) {
            // fallback: remove surrogate pairs (most emojis) and common pictographs
            return s.replace(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g, '').replace(/[\u2600-\u26FF\u2700-\u27BF]/g, '');
        }
    };

    // More robust whitelisting sanitizers
    const sanitizeNameValue = (s) => {
        if (!s) return '';
        try {
            const chars = Array.from(s);
            return chars.filter(ch => {
                if (!ch) return false;
                // allow ASCII digits
                if (/\d/.test(ch)) return true;
                // allow common punctuation in names
                if (ch === ' ' || ch === "'" || ch === '-' || ch === '.') return true;
                // allow letters (quick Unicode letter test)
                try {
                    if (ch.toLowerCase() !== ch.toUpperCase()) return true;
                } catch (e) {}
                return false;
            }).join('');
        } catch (e) {
            return s.replace(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g, '');
        }
    };

    const sanitizeUserNameValue = (s) => {
        if (!s) return '';
        // username: allow lowercase letters, numbers, dot, underscore and hyphen
        return s.toLowerCase().replace(/[^a-z0-9_.-]/g, '');
    };

    const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    const passRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/;
    

    const notifyA = (msg) => toast.error(msg);
    const notifyB = (msg) => toast.success(msg);
    const [loading, setLoading] = useState(false);

    const postData = () => {
        setLoading(true);
        if (!name || !userName || !email || !password || !phone || !interests || !bio) {
            setLoading(false);
            notifyA("Please add all the fields");
            return;
        } else if (!emailRegex.test(email)) {
            setLoading(false);
            notifyA("Invalid Email");
            return;
        } else if (!passRegex.test(password)) {
            setLoading(false);
            notifyA("Password must contain at least 8 characters, including at least 1 number and 1 uppercase letter and special characters like #,?,!");
            return;
        }

        const cleanPhone = phone.replace(/\D/g, '');
        if (cleanPhone.length !== 10) {
            setLoading(false);
            notifyA("Please enter a valid 10-digit Indian phone number");
            return;
        }

        if (name.length > 100) { setLoading(false); notifyA('Name cannot exceed 100 characters'); return; }
        if (userName.length > 30) { setLoading(false); notifyA('Username cannot exceed 30 characters'); return; }
        if (email.length > 100) { setLoading(false); notifyA('Email cannot exceed 100 characters'); return; }

        if (!interests || interests.trim().length === 0) { setLoading(false); notifyA('Please add at least one interest'); return; }
        if (interests.length > 80) { setLoading(false); notifyA('Interests cannot exceed 80 characters'); return; }

        if (bio.length > 130) {
            setLoading(false);
            notifyA("Bio cannot be more than 130 characters");
            return;
        }
        if (!about || about.trim().length === 0) {
            setLoading(false);
            notifyA("Please add About");
            return;
        }
        if (about.length > 1000) {
            setLoading(false);
            notifyA("About cannot be more than 1000 characters");
            return;
        }

        fetch("/signup", {
            method: "post",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                name,
                userName: userName.toLowerCase(),
                email,
                password,
                phone: cleanPhone,
                interests,
                // state,
                // country,
                bio,  // Include bio in the request body
                about
            })
        }).then(res => res.json())
            .then(data => {
                setLoading(false);
                if (data.error) {
                    notifyA(data.error);
                } else {
                    notifyB(data.message);
                    navigate("/signin");
                }
            }).catch(err => { setLoading(false); notifyA('Network error'); console.error(err); });
    };

    const continueWithGoogle = (credentialResponse) => {
        const jwtDetail = jwtDecode(credentialResponse.credential);
        fetch("/googleLogin", {
            method: "post",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                name: jwtDetail.name,
                userName: (jwtDetail.sub || '').toLowerCase(),
                email: jwtDetail.email,
                email_verified: jwtDetail.email_verified,
                clientId: credentialResponse.clientId,
                Photo: jwtDetail.picture
            })
        }).then(res => res.json())
            .then(data => {
                if (data.error) {
                    notifyA(data.error);
                } else {
                    notifyB("Signed In Successfully");
                    localStorage.setItem("jwt", data.token);
                    localStorage.setItem("user", JSON.stringify(data.user));
                    setUserLogin(true);
                    // notify app to reinitialize sockets and counters
                    try { window.dispatchEvent(new CustomEvent('user-changed')); } catch(e){}
                    navigate("/");
                }
            });
    };

    return (
        <div className='signUp'>
            <div className="form-container">
                <div className="form">
                    <img className='signUpLogo' src={logo} alt="Logo" />
                    <h1 className='appName'>Linkalikes</h1>
                    <p className='pointLine' style={{marginTop:"-22px"}}>Only for LIVING beings!!</p>
                    <p className='headPara'>
                        find PEOPLE
                    </p>
                    <p className='headPara'>
                        who SHARE YOUR INTERESTS
                    </p>
                    <p className='headPara'>
                        & MAKE NEW FRIENDS
                    </p>
                    <div className='actionButtons' style={{display:'flex', flexDirection:'column', alignItems:"center", gap:12, justifyContent:'center', width:'100%', marginTop:12}}>
                        <button id='signUpToggle' onClick={() => setHideSignUp(!hideSignUp)}>Create An Account (Sign Up)</button>
                    </div>
                    <div style={{backgroundColor:"black", borderRadius:"15px", padding:"15px"}} className={hideSignUp ? '' : 'signupHide'}>
                        <div>
                            <input
                            className='mainInputs'
                            type="email"
                            name="email"
                            id='email'
                            value={email}
                            placeholder='Email'
                            onChange={(e) => setEmail(e.target.value)}
                            maxLength={120}
                            />
                        </div>
                        <div>
                            <input
                                className='mainInputs'
                                type="text"
                                name="name"
                                id='name'
                                placeholder='Full Name'
                                value={name}
                                onChange={(e) => setName(sanitizeNameValue(e.target.value).slice(0,120))}
                                onPaste={(e) => { e.preventDefault(); const pasted = (e.clipboardData || window.clipboardData).getData('text'); setName(sanitizeNameValue(pasted).slice(0,120)); }}
                                maxLength={120}
                            />
                        </div>
                        <div>
                            <input
                                className='mainInputs'
                                type="text"
                                name="username"
                                id='username'
                                placeholder='Username (lowercase only)'
                                value={userName}
                                onChange={(e) => setUserName(sanitizeUserNameValue(e.target.value).slice(0,120))}
                                onPaste={(e) => { e.preventDefault(); const pasted = (e.clipboardData || window.clipboardData).getData('text'); setUserName(sanitizeUserNameValue(pasted).slice(0,120)); }}
                                maxLength={120}
                            />
                        </div>
                        <div>
                            <input className='mainInputs' type="password" name="password" id='password' placeholder='Password' value={password} onChange={(e) => setPassword(e.target.value.slice(0,120))} maxLength={120} />
                        </div>
                        <div>
                            <input
                                className='mainInputs'
                                type="tel"
                                name="phone"
                                id='phone'
                                placeholder='Phone Number (10 digits)'
                                value={phone}
                                onChange={(e) => {
                                    const digits = e.target.value.replace(/\D/g, '').slice(0, 10);
                                    setPhone(digits);
                                }}
                                maxLength={10}
                            />
                        </div>
                        <div>
                            <input
                                className='mainInputs dropdowns'
                                type='text'
                                name="interests"
                                id='interests'
                                placeholder='basket, football, singing.. => (type your interests) (single line, ~7 items)'
                                value={interests}
                                onChange={(e) => setInterests(e.target.value)}
                                maxLength={120}
                            />
                        </div>
                        {/* <div>
                            <select className='mainInputs dropdowns' name="state" id='state' value={state} onChange={(e) => setState(e.target.value)}>
                                <option value="" disabled>Select your state</option>
                                <option value="California">California</option>
                                <option value="Texas">Texas</option>
                                <option value="New York">New York</option>
                                <option value="Florida">Florida</option>
                                Add other states as needed....
                            </select>
                        </div> */}
                        {/* <div>
                            <select className='mainInputs dropdowns' name="country" id='country' value={country} onChange={(e) => setCountry(e.target.value)}>
                                <option value="" disabled>Select your country</option>
                                <option value="USA">USA</option>
                                <option value="Canada">Canada</option>
                                <option value="UK">UK</option>
                                <option value="Australia">Australia</option>
                                Add other countries as needed
                            </select>
                        </div> */}
                        <div>  {/* About field with counter */}
                            <textarea className='mainInputs' name="about" id='about' placeholder='About (brief) - occupation, studies, achievements, hobbies' value={about} onChange={(e) => { setAbout(e.target.value); setAboutCount(e.target.value.length); }} maxLength={1000} style={{minHeight:120}} />
                            <div style={{textAlign:'right',fontSize:12,color:'#666'}}>{aboutCount}/1000</div>
                        </div>
                        <div>  {/* Bio field with counter */}
                            <textarea className='mainInputs' name="bio" id='bio' placeholder='Bio' value={bio} onChange={(e) => { setBio(e.target.value); setBioCount(e.target.value.length); }} maxLength={130} style={{minHeight:80}} />
                            <div style={{textAlign:'right',fontSize:12,color:'#666'}}>{bioCount}/130</div>
                        </div>
                        <div style={{fontSize:"15px", marginBottom:"15px", marginTop:"15px"}}>By tapping "Agree & Sign Up", you agree to the <a href="/terms-of-use" target="_blank" rel="noopener noreferrer" style={{color:'yellow', backgroundColor:"black", textDecoration:"underline"}}>Terms of Use</a> agreement and <a href="/privacy-policy" target="_blank" rel="noopener noreferrer" style={{color:'yellow', backgroundColor:"black", textDecoration:"underline"}}>Privacy Policy</a></div>
                        <button type="button" id='submit-btn' onClick={postData} disabled={loading}>
                            {loading ? <span className="btn-spinner" /> : 'Agree & Sign Up'}
                        </button>
                    </div>
                    <button id='signInToggle' onClick={() => navigate('/signin')}>Login</button>
                    <br />
                    
                    {/* -------------- */}
                    <hr />
                    {/* Already have an account? 
                    <Link to="/signin">
                        <span style={{ color:'yellow', backgroundColor:"black", cursor: 'pointer' }}>Login</span>
                    </Link> */}
                    <br />
                    <div style={{ backgroundColor:"black", display:"flex", flexDirection:"column", alignItems:"center", marginTop:"10px", width:"100%"}}>
                      <p>a <b>Subodh Sathe</b> creation</p>
                      <b>Linkalikes &copy; 2026</b>

                      <a href="/support" target="_blank" rel="noopener noreferrer" style={{color:'yellow', backgroundColor:"black", textDecoration:"underline", marginTop:6, display:'inline-block'}}>Contact Us</a>
                      <a href="/privacy-policy" target="_blank" rel="noopener noreferrer" style={{color:'yellow', backgroundColor:"black", textDecoration:"underline", marginTop:6, display:'inline-block'}}>Privacy Policy</a>
                      <a href="/csae-standards" target="_blank" rel="noopener noreferrer" style={{color:'yellow', backgroundColor:"black", textDecoration:"underline", marginTop:6, display:'inline-block', marginBottom:"15px"}}>CSAE Standards</a>

                    </div>
                </div>
            </div>
        </div>
    );
}
